// extracted by mini-css-extract-plugin
export var cardHeader = "_gz-1";
export var contentCard = "_gz-0";
export var headerActions = "_gz-3";
export var reorderHandle = "_gz-5";
export var titleArea = "_gz-2";
export var titleAreaWithHandle = "_gz-4";